export const impressum = {
  company: {
    name: 'Süd Ausbau GmbH',
    legalForm: 'GmbH',
    ceo: 'Max Mustermann',
    representative: '',
  },
  address: {
    street: 'Musterstraße 1',
    zip: '80331',
    city: 'München',
  },
  contact: {
    phone: '+49 (0) 89 123 456 78',
    fax: '+49 (0) 89 123 456 79',
    email: 'info@sued-ausbau.de',
    website: 'www.sued-ausbau.de',
  },
  legal: {
    court: 'Amtsgericht München',
    registrationNumber: 'HRB 123456',
    vatId: 'DE 123 456 789',
    taxNumber: '',
  },
  disclaimer: `Haftung für Inhalte: Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.`,
  linkDisclaimer: `Haftung für Links: Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.

Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.`,
  copyright: `Urheberrecht: Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.`,
};

export const datenschutz = {
  title: 'Datenschutzerklärung',
  intro: 'Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TMG).',
  sections: [
    {
      title: '1. Verantwortlicher',
      content: `Süd Ausbau GmbH
Musterstraße 1
80331 München
E-Mail: info@sued-ausbau.de
Telefon: +49 (0) 89 123 456 78`,
    },
    {
      title: '2. Erhebung und Speicherung personenbezogener Daten',
      content: `Beim Besuch unserer Website werden durch den auf Ihrem Gerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sog. Logfile gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:

• IP-Adresse des anfragenden Rechners
• Datum und Uhrzeit des Zugriffs
• Name und URL der abgerufenen Datei
• Website, von der aus der Zugriff erfolgt (Referrer-URL)
• Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners`,
    },
    {
      title: '3. Kontaktformular',
      content: 'Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).',
    },
    {
      title: '4. Ihre Rechte',
      content: `Sie haben das Recht:

• Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)
• Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)
• Löschung Ihrer bei uns gespeicherten Daten zu verlangen (Art. 17 DSGVO)
• Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)
• Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)
• Sich bei einer Aufsichtsbehörde zu beschweren (Art. 77 DSGVO)`,
    },
    {
      title: '5. SSL-Verschlüsselung',
      content: 'Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.',
    },
  ],
};

export const agb = {
  title: 'Allgemeine Geschäftsbedingungen',
  sections: [
    {
      title: '§ 1 Geltungsbereich',
      content: 'Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen der Süd Ausbau GmbH (nachfolgend „Auftragnehmer") und dem Auftraggeber über Bauleistungen, insbesondere Innenausbau, Trockenbau, Sanierung und Umbauarbeiten.',
    },
    {
      title: '§ 2 Vertragsschluss',
      content: 'Angebote des Auftragnehmers sind freibleibend und unverbindlich. Ein Vertrag kommt erst durch schriftliche Auftragsbestätigung des Auftragnehmers oder durch Beginn der Ausführung der Leistung zustande.',
    },
    {
      title: '§ 3 Leistungsumfang',
      content: 'Der Umfang der Leistungen ergibt sich aus der Leistungsbeschreibung des Angebots bzw. der Auftragsbestätigung. Änderungen und Ergänzungen bedürfen der schriftlichen Vereinbarung.',
    },
    {
      title: '§ 4 Vergütung',
      content: 'Die Vergütung richtet sich nach dem vereinbarten Angebot. Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer. Zusatzleistungen, die über den vereinbarten Leistungsumfang hinausgehen, werden nach tatsächlichem Aufwand berechnet.',
    },
    {
      title: '§ 5 Zahlungsbedingungen',
      content: 'Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zahlbar. Bei Zahlungsverzug werden Verzugszinsen in gesetzlicher Höhe berechnet.',
    },
    {
      title: '§ 6 Gewährleistung',
      content: 'Die Gewährleistungsfrist beträgt 5 Jahre ab Abnahme der Leistung, sofern nicht anders vereinbart. Die Gewährleistung umfasst die Beseitigung von Mängeln durch Nachbesserung.',
    },
    {
      title: '§ 7 Haftung',
      content: 'Der Auftragnehmer haftet für Schäden nur bei Vorsatz und grober Fahrlässigkeit. Die Haftung für leichte Fahrlässigkeit ist auf die Verletzung wesentlicher Vertragspflichten beschränkt.',
    },
    {
      title: '§ 8 Schlussbestimmungen',
      content: 'Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist München. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.',
    },
  ],
};
